module.exports = __webpack_public_path__ + "img/img-logo-01-v3.46bba6f9.png";